export const workspaceNameSanitizer = (workspaceName: string): string => {
    const sanitizedWorkspaceName = workspaceName.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")                // Remove diacritics
        .replace(/[^a-zA-Z0-9\s]+/g, "");               // Remove special characters
    return sanitizedWorkspaceName.trim();
};